import { useContext, useEffect, useState } from "react";
import Cards from "../../../assets/images/carde.png";

// @styles
import "./styles.scss";
import "../small-switch/styles.scss";
import ModalChangePlan from "components/modal-change";
import Context from "context/appContext";
import { Card, notification } from "antd";
import {
  coverageChoosed,
  coveragesSelected,
  formatPrice,
  getSidebarCoverage,
  getValueCoverage,
  keysSideBarResume,
} from "utils/utils";

export default function CardsAdditional({ info, key, form, current }) {
  const [defaultClass, setDefaultClass] = useState("default");
  const [coverageSelect, setCoverageSelect] = useState([]);
  const [api, contextHolder] = notification.useNotification();
  const [changeModalitie, setChangeModalitie] = useState("");
  const [otherCoverageSelect, setOtherCoverageSelect] = useState([]);
  const [openModalChange, setOpenModalChange] = useState(false);
  const {
    dataForm: { data, formResponses },
    coverageAdd,
    modalities,
    priceToShow,
    sidebarData,
    isSideBarUpdate,
    modality,
    totalCoverages,
    cleanAditionalCoverages,
    setPriceToShow,
    setSidebarData,
    setIsSideBarUpdate,
    setModality,
    setCleanAditionalCoverages
  } = useContext(Context);
  const messageAdd = "Tu cobertura ha sido agregada con éxito";
  const messageRemove = "Tu cobertura adicional ha sido removida con éxito";

  const showModal = (othCoverage) => {
    let onChangeModalitie = modalities.find(
      (e) => e.modality === othCoverage.modality
    );
    othCoverage["modalityId"] = onChangeModalitie.modalityId;
    setChangeModalitie(othCoverage);
    setOpenModalChange(true);
  };

  useEffect(() => {
    getValues();
  }, []);

  const getValues = () => {
    const searchModalitie = formResponses.find((res) => res.key === "coberturas");
    if (searchModalitie) {
      if (!isSideBarUpdate) {
        let { coverageSelect, otherCoverage } = coveragesSelected(searchModalitie, coverageAdd, modalities);
        const dataSideBar = getSidebarCoverage(searchModalitie, formResponses);
        if (cleanAditionalCoverages) {
          coverageSelect.forEach(x => {
            if (x.choosed) {
              x.choosed = false
            }
          })
        }
        setSidebarData(dataSideBar);
        setCoverageSelect(coverageSelect);
        setOtherCoverageSelect(otherCoverage);
        setCleanAditionalCoverages(false);
      } else {
        let { selectedCoverages, otherCoverage } = coverageChoosed(
          searchModalitie.coverages.filter((e) => e.choosed),
          modality,
          modalities,
          coverageAdd
        );
        setCoverageSelect(selectedCoverages);
        setOtherCoverageSelect(otherCoverage);
      }
      !modality && setModality(searchModalitie);
    }
  };

  const calculatePrice = (coverageSelected) => {
    if (coverageSelected && typeof coverageSelected.value === "number") {
      if (coverageSelected.choosed) {
        setPriceToShow(priceToShow + coverageSelected.value);
      } else {
        setPriceToShow(priceToShow - coverageSelected.value);
      }
    }
  };

  const getNotificationStyle = (type) => {
    return {
      success: {
        color: "#707070",
        backgroundColor: "#FFF",
        borderTopRightRadius: "14px",
        borderTopLeftRadius: "14px",
        borderBottomLeftRadius: "14px",
        borderBottomRightRadius: "14px",
        fontFamily: "Arial",
        fontSize: "16px",
      },
      error: {
        color: "#707070",
        backgroundColor: "#FFF",
        borderTopRightRadius: "14px",
        borderTopLeftRadius: "14px",
        borderBottomLeftRadius: "14px",
        borderBottomRightRadius: "14px",
        fontFamily: "Arial",
        fontSize: "16px",
      },
    }[type];
  };

  const openNotificationWithIcon = (type, description) => {
    api[type]({
      message: ``,
      description,
      style: getNotificationStyle(type),
    });
  };

  const openNotification = (choosed) => {
    if (choosed) {
      openNotificationWithIcon("success", messageAdd);
    } else {
      openNotificationWithIcon("error", messageRemove);
    }
  };

  const updateSideBar = (choosed, coverage) => {
    const copySideBar = sidebarData.findIndex((e) => e.key === "coverageA");
    const searchFormResponse = formResponses.findIndex((e) => e.key === "coberturas");
    if (choosed) {
      const propertie = {
        id: coverage.coverageId,
        label: coverage.coverageName,
        value: `${formatPrice(coverage.value).toString()}`,
      };
      const addCoverage = [...sidebarData[copySideBar].items[0].values, propertie];
      sidebarData[copySideBar].items[0].values = addCoverage;
      formResponses[searchFormResponse].coverages.push(coverage);
    } else {
      let copyCoverage = sidebarData[copySideBar].items[0].values.filter((e) => e.id != coverage.coverageId);
      let copyFormResponse = formResponses[searchFormResponse].coverages.filter((e) => e.coverageId != coverage.coverageId);
      sidebarData[copySideBar].items[0].values = copyCoverage;
      formResponses[searchFormResponse].coverages = copyFormResponse;
    }
  };

  const onClick = (cov, choosed) => {
    setIsSideBarUpdate(true);
    const findCov = coverageSelect.findIndex((coverage) => coverage.coverageId === cov.coverageId);
    coverageSelect[findCov].choosed = choosed;
    calculatePrice(coverageSelect[findCov]);
    updateSideBar(choosed, coverageSelect[findCov]);
    openNotification(choosed);
    setCoverageSelect(coverageSelect);
    setDefaultClass("active-btn-left");
  };

  const updateResponse = (covera, onChangeModalitie) => {
    const searchFormResponse = formResponses.findIndex((e) => e.key === "coberturas");
    formResponses[searchFormResponse] = {
      key: "coberturas",
      ...formResponses[searchFormResponse],
      coverages: covera,
      ...onChangeModalitie,
    };
    const copySideBar = sidebarData.findIndex((e) => e.key === "coverages");
    sidebarData[copySideBar].items[0].values = getValueCoverage(formResponses[searchFormResponse]);
    const updatePrice = priceToShow - Math.trunc(modality.value);
    setPriceToShow(updatePrice + onChangeModalitie.value);
  };

  const onChangeCoverages = (covSelected) => {
    let onChangeModalitie = modalities.find((e) => e.modalityId === covSelected);
    let copyOtherCoverageSelect = [];
    const coveragesSelecteded = coveragesSelected(onChangeModalitie, totalCoverages);
    let copyCoverageSelect = [...coverageSelect];
    otherCoverageSelect.forEach((other) => {
      if (other.modalities[covSelected]) {
        copyCoverageSelect.push(other);
      } else {
        copyOtherCoverageSelect.push(other);
      }
    });
    updateResponse(coveragesSelecteded, onChangeModalitie);
    setOtherCoverageSelect(copyOtherCoverageSelect);
    setCoverageSelect(copyCoverageSelect);
    setOpenModalChange(!openModalChange);
    setModality(onChangeModalitie);
  };
  return (
    <>
      {contextHolder}
      <div className="coverages-economy additional-card">
        {coverageSelect.length > 0 && (
          <div className="coverages-economy__title">
            <p>
              ¡Puedes incluir nuestros nuevos beneficios a tu cobertura{" "}
              <strong>{modality.modality}</strong>!
            </p>
          </div>
        )}
        <div className="coverages-economy__content">
          <div className="coverages-economy__content-additionalcards">
            {coverageSelect.map((cov, index) => (
              <div
                className="coverages-economy__content-additionalcards__item"
                key={index}
              >
                <img
                  className="coverages-economy__content-additionalcards__item-img"
                  src={cov.image === 'url' ? Cards : cov.image}
                  alt={cov.coverageName}
                />
                <div className="coverages-economy__content-additionalcards__item-text">
                  <strong>{cov.coverageName}</strong>
                  <p>{cov.description}</p>
                </div>
                <div className="coverages-economy__content-additionalcards__item-actions">
                  <div className="coverages-economy__content-additionalcards__item-actions__price">
                    {formatPrice(cov.value)}
                  </div>
                  <div className="smallswitch__container" id={index}>
                    <div className="smallswitch__container__buttons" id={index}>
                      <button
                        className={`smallswitch__container__buttons-btn ${!cov.choosed ? "active-btn-left" : ""
                          }`}
                        disabled={!cov.choosed}
                        data-testid="click-card-3"
                        onClick={() => onClick(cov, false)}
                      >
                        <span>No</span>
                      </button>
                      <button
                        className={`smallswitch__container__buttons-btn ${cov.choosed ? "active-btn-right" : ""
                          }`}
                        disabled={cov.choosed}
                        data-testid="click-card-7"
                        onClick={() => onClick(cov, true)}
                      >
                        <span>Si</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {otherCoverageSelect.length > 0 && (
          <>
            <div className="coverages-economy__title">
              <p>Beneficios adicionales al contratar otra cobertura</p>
            </div>
            <div className="coverages-economy__content">
              <div className="coverages-economy__content-additionalcards">
                {otherCoverageSelect.map((othCoverage, index) => (
                  <div
                    onClick={() => showModal(othCoverage)}
                    className="coverages-economy__content-additionalcards__item"
                  >
                    <img
                      className="coverages-economy__content-additionalcards__item-img"
                      src={othCoverage.image === 'url' ? Cards : othCoverage.image}
                      alt={othCoverage.coverageName}
                    />
                    <div className="coverages-economy__content-additionalcards__item-text padding-top">
                      <strong>{othCoverage.coverageName}</strong>
                      <p>{othCoverage.description}</p>
                    </div>
                    <div
                      className="coverages-economy__content-additionalcards__item-actions action-text"
                    >
                      <a
                        alt={othCoverage.coverageName}
                        className="coverages-economy__content-additionalcards__item-actions-included"
                        data-testid="btn-modal"
                      >
                        {othCoverage.modality}
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
      <ModalChangePlan
        visible={openModalChange}
        modalitie={changeModalitie}
        onClose={() => {
          setOpenModalChange(!openModalChange);
        }}
        onOk={(covModalitie) => onChangeCoverages(covModalitie)}
      />
    </>
  );
}
